import { HttpHandler } from 'msw'

import { createEmailSettings } from './createEmailSettings'
import { getEmailSettings } from './getEmailSettings'
import { updateEmailSettings } from './updateEmailSettings'

export const emailSettings: HttpHandler[] = [
    createEmailSettings,
    getEmailSettings,
    updateEmailSettings,
]
